import { LANGUAGE_OPTIONS, APP_NAMES, APP_UI_TEXTS, TRASH_LABELS } from './texts'

export const DEFAULT_LANGUAGE = 'us'

export const SUPPORTED_LANGUAGES = LANGUAGE_OPTIONS.map(item => item.id)

const LANGUAGE_ALIASES = {
  en: 'us',
  'en-us': 'us',
  us: 'us',
  'en-gb': 'uk',
  gb: 'uk',
  cn: 'zh',
  'zh-cn': 'zh',
  'zh-hans': 'zh',
  'zh-tw': 'tw',
  'zh-hant': 'tw'
}

const TEMPLATE_FOLDER_LABELS = {
  zh: '\u56fe\u7247\u6a21\u7248',
  tw: '\u5716\u7247\u7bc4\u672c',
  nl: 'Afbeeldingssjablonen',
  uk: 'Image templates',
  us: 'Image templates',
  fr: 'Mod\u00e8les d\u2019image',
  de: 'Bildvorlagen',
  it: 'Modelli di immagini',
  ja: '\u753b\u50cf\u30c6\u30f3\u30d7\u30ec\u30fc\u30c8',
  ko: '\uc774\ubbf8\uc9c0 \ud15c\ud50c\ub9bf',
  pt: 'Modelos de imagem',
  ru: '\u0428\u0430\u0431\u043b\u043e\u043d\u044b \u0438\u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u0438\u0439',
  es: 'Plantillas de imagen'
}

const RESOURCE_ITEM_UNIT_LABELS = {
  zh: '\u9879',
  tw: '\u9805',
  nl: 'items',
  uk: 'item',
  us: 'item',
  fr: '\u00e9l\u00e9ments',
  de: 'Elemente',
  it: 'elementi',
  ja: '\u9805\u76ee',
  ko: '\ud56d\ubaa9',
  pt: 'itens',
  ru: '\u044d\u043b\u0435\u043c.',
  es: 'elementos'
}

function resolveTemplateFolderLanguage(value) {
  const key = String(value || '').trim().toLowerCase().replace('_', '-')
  const language = LANGUAGE_ALIASES[key] || key
  return Object.prototype.hasOwnProperty.call(TEMPLATE_FOLDER_LABELS, language) ? language : ''
}

export function normalizeLanguage(value) {
  const key = String(value || '').trim().toLowerCase().replace('_', '-')
  const language = LANGUAGE_ALIASES[key] || key
  return SUPPORTED_LANGUAGES.includes(language) ? language : DEFAULT_LANGUAGE
}

export function getLanguageOption(value) {
  const language = normalizeLanguage(value)
  return LANGUAGE_OPTIONS.find(item => item.id == language) || LANGUAGE_OPTIONS.find(item => item.id == DEFAULT_LANGUAGE)
}

export function mergeLanguageText(textMap, language) {
  const normalized = normalizeLanguage(language)
  return Object.assign({}, textMap[DEFAULT_LANGUAGE] || {}, textMap[normalized] || {})
}

export function getAppName(value) {
  const key = String(value || '').trim().toLowerCase()
  return APP_NAMES[key] || ''
}

export function getAppUiText(language) {
  return mergeLanguageText(APP_UI_TEXTS, language)
}

export function getTrashLabel(language) {
  const normalized = normalizeLanguage(language)
  return TRASH_LABELS[normalized] || TRASH_LABELS[DEFAULT_LANGUAGE]
}

export function getTemplateFolderLabel(language) {
  const normalized = resolveTemplateFolderLanguage(language)
  return normalized ? TEMPLATE_FOLDER_LABELS[normalized] : ''
}

export function getResourceItemUnitLabel(language) {
  const normalized = normalizeLanguage(language)
  return RESOURCE_ITEM_UNIT_LABELS[normalized] || RESOURCE_ITEM_UNIT_LABELS[DEFAULT_LANGUAGE]
}

export function getTemplateFolderDisplayName(name, language, isTemplateFolder = false) {
  const text = String(name || '').trim()
  if (!isTemplateFolder) {
    return text
  }
  return getTemplateFolderLabel(language) || text
}
